module.exports = __webpack_public_path__ + "static/media/redHat.a996dd4b.webp";